import { gql } from "@apollo/client";

export const GET_OPTION_GROUPS = gql`
  query OptionGroup($vestiging_id: ID!, $id: [Int], $name: String, $idNameApiId: String, $pageSize: Int, $page: Int) {
    option_groups(
      vestiging_id: $vestiging_id
      id: $id
      name: $name
      idNameApiId: $idNameApiId
      first: $pageSize
      page: $page
    ) {
      data {
        id
        name
        sort_key
        apiId
        is_active_in_pos
        is_active_in_jamezz
        min_count
        max_count
      }
      paginatorInfo {
        perPage
        currentPage
        total
      }
    }
  }
`;
